<template>
  <div class="manager_box" v-loading="loading">
    <div class="main">
      <div class="add_form">
        <div class="line">
          <div class="title">用户名：</div>
          <el-input
            v-model="username"
            class="input"
            oninput="if(value.length>11)value=value.slice(0, 11)"
            placeholder="请输入内容"
            type="number"
          ></el-input>
        </div>
        <div class="line">
          <div class="title">密码：</div>
          <el-input
            v-model="password"
            class="input"
            maxlength="16"
            @input="password = password.replace(/[^A-Za-z0-9]/g, '')"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="line">
          <div class="title">公司名称：</div>
          <el-input
            v-model.trim="company"
            class="input"
            placeholder="请输入内容"
          ></el-input>
        </div>
      </div>
      <div class="add_form">
        <div class="line">
          <div class="title">选择代理商：</div>
          <el-cascader
            class="input"
            v-model="agent_value"
            :options="agent_data"
          ></el-cascader>
          <span style="display: inline">
            <el-tooltip placement="top"> </el-tooltip>
          </span>
        </div>
        <div class="line" style="margin-bottom: 21px">
          <div class="title">权限：</div>
          <el-radio-group v-model="jurisdiction" @change="switch_">
            <el-radio :label="0">厂商</el-radio>
            <el-radio :label="1">省代</el-radio>
            <el-radio :label="2">市代理商</el-radio>
            <el-radio :label="4">客户</el-radio>
          </el-radio-group>
        </div>
        <div class="line">
          <div class="title">会员开通时间：</div>
          <el-date-picker
            v-model="vip_time"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          ></el-date-picker>
        </div>
      </div>
      <div class="button">
        <el-row>
          <el-button type="primary" @click="create_user">确认开通</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { require, url_Api } from "@/utils/http_request.js";
export default {
  data() {
    return {
      loading: false,
      // 用户名
      username: "",
      //密码
      password: "",
      // 公司名称
      company: "",
      // 代理商列表
      agent_data: [],
      agent_value: "",
      //  权限
      jurisdiction: 0,
      //   会员时间
      vip_time: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    // 权限更改调用代理商列表接口
    switch_() {
      this.agent_data =[]
      this.agent_value = ''
      this.create_hrswork()
    },
    //  判断
    create_user() {
      if (this.username.length != 11 || !this.username) {
        this.$message.error("请输入11位用户名");
        return false;
      }
      if (!this.password) {
        this.$message.error("请输入密码");
        return false;
      } else if (this.password.length < 5) {
        this.$message.error("密码长度不够");
        return false;
      }
      if (!this.company) {
        this.$message.error("请输入公司名称");
        return false;
      }
      if (!this.agent_value) {
        this.$message.error("请选择代理商");
        return false;
      }
      if (!this.vip_time) {
        this.$message.error("请选择会员开通时间");
        return false;
      }
      this.register();
    },
    // 注册
    register() {
      this.loading = true;
      var register_data = {
        username: this.username,
        password: this.password,
        agent_id: this.agent_value[2],
        name: this.company,
        tr_id: this.jurisdiction,
        vip_start_time: this.vip_time[0].getTime() / 1000,
        vip_end_time: this.vip_time[1].getTime() / 1000,
      };
      require("post", "/hrswork/v1/register/", { register_data }).then(
        (res) => {
          if (!res.code) {
            this.loading = false;
            this.$message.success("创建成功");
            this.initial();
          }
        }
      );
    },
    // 初始化
    initial() {
      this.username = "";
      this.password = "";
      this.agent_value = "";
      this.company = "";
      this.jurisdiction = 0;
      this.vip_time = "";
    },
    // 获取全部代理商
    show_agent_city() {
      console.log("大使");
      require("post", "/hr24_user/v1/show_agent_city/", {}).then((res) => {
        console.log("res", res);
        this.agent_data = res.data;
      });
    },
    // 根据权限获取代理商列表
    create_hrswork() {
      require("post", "/hrswork/v1/create_hrswork/", {
        status: this.jurisdiction,
      }).then((res) => {
        this.agent_data = res.data;
      });
    },
  },
  created() {
    this.create_hrswork();
  },
};
</script>



<style scoped>
.el-radio {
  margin-right: 10px !important;
}
.main {
  display: flex;
  justify-content: wrap;
  width: 1020px;
  flex-wrap: wrap;
  justify-content: center;
}
.add_form {
  width: 50%;
}
.line {
  display: flex;
  font-size: 14px;
}
.line .title {
  width: 150px;
  line-height: 40px;
  text-align: right;
}
.line .input {
  width: 360px;
  margin-bottom: 30px;
}
.el-radio-group {
  display: flex;
  align-items: center;
}
.el-button--mini,
.el-button--small {
  font-size: 14px;
  width: 220px;
  height: 50px;
  border-radius: 3px;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/lielingyun/create_lie.vue